module.exports = __webpack_public_path__ + "static/media/icons-solid-check.d36df139.svg";